import FormFieldTimestamp from "components/FormFields/Timestamp";
import FormFieldViewText from "components/FormFields/ViewText";
import UserStatusBadge from "components/UserStatusBadge";
import Banner from "ds/components/Banner";
import LinkButton from "ds/components/Button/LinkButton";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import FeedbackActions from "ds/components/Feedback/Actions";
import FormField from "ds/components/Form/Field";
import Icon from "ds/components/Icon";
import Typography from "ds/components/Typography";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { getProviderLogo } from "views/Account/Settings/Users/helpers";

import { UserManagementActivationStatus } from "../../types";
import styles from "./styles.module.css";
import { UserDetails } from "./types";

type UsersDetailsDrawerContentProps = {
  user: UserDetails;
  activationStatus: UserManagementActivationStatus;
};

const UsersDetailsDrawerContent = ({ activationStatus, user }: UsersDetailsDrawerContentProps) => {
  const ProviderIcon = getProviderLogo(user.loginMethod);

  return (
    <>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="User details" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody fullHeight hasStickyFooter>
        {activationStatus === UserManagementActivationStatus.INACTIVE && (
          <Banner variant="warning" title="User management is inactive">
            Access rules will not take effect until you activate user management.
            <FeedbackActions>
              <LinkButton
                to="/settings/management-strategy/"
                analyticsPage={AnalyticsPageOrganization.OrganizationUsers}
                analyticsTitle="Callout Strategy Click"
                variant="contrast"
                size="small"
              >
                Choose strategy
              </LinkButton>
            </FeedbackActions>
          </Banner>
        )}

        <FormFieldViewText label="Username" value={user.username} />

        <FormField label="Login method">
          <Typography tag="span" variant="p-body2">
            {typeof ProviderIcon === "string" ? (
              ProviderIcon
            ) : (
              <Icon size="large" src={ProviderIcon} />
            )}
          </Typography>
        </FormField>
        {user.invitationEmail && <FormFieldViewText label="Email" value={user.invitationEmail} />}
        {user.lastLoginTime && (
          <FormFieldTimestamp timestamp={user.lastLoginTime} label="Last login" />
        )}

        <FormField label="Status" className={styles.status}>
          <UserStatusBadge status={user.status} />
        </FormField>

        {user.latestGroups.length > 0 && (
          <FormField label="User groups passed by identity provider">
            {user.latestGroups.map((group, index) => (
              <Typography key={index} tag="span" variant="p-body3">
                {group}
              </Typography>
            ))}
          </FormField>
        )}
      </DrawerBody>
    </>
  );
};

export default UsersDetailsDrawerContent;
